"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.skipLinks = void 0;
const basic_1 = require("../basic");
const colors_1 = require("../basic/colors");
const fonts_1 = require("../basic/fonts");
exports.skipLinks = (0, basic_1.applyBase)({
    skipLink: {
        clip: 'rect(0,0,0,0)',
        border: '0',
        display: 'block',
        height: '1px',
        margin: '-1px',
        overflow: 'hidden',
        padding: '1rem',
        position: 'absolute',
        transition: 'padding 0s',
        width: '1px',
        background: colors_1.colors.primary,
        color: colors_1.colors.white,
        fontSize: fonts_1.fontSizes[2],
        '&:focus': {
            height: 'auto',
            margin: '0.5rem',
            overflow: 'initial',
            position: 'relative',
            width: 'auto',
        },
        '&:hover': {
            color: colors_1.colors.white,
        },
    },
    skipLinksWrapper: {
        position: 'fixed',
        zIndex: 1000,
    },
    skipLinksTitle: {
        display: 'none',
    },
});
//# sourceMappingURL=skip-links.js.map